var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoStar24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_star24x24",
    d: "M15.64,8.3a1.229,1.229,0,0,0,.3-1.23A1.156,1.156,0,0,0,15,6.253L11.13,5.666a.508.508,0,0,1-.381-.289L9.019,1.716a1.121,1.121,0,0,0-2.055,0L5.233,5.378a.508.508,0,0,1-.381.289L.983,6.254a1.156,1.156,0,0,0-.934.812A1.229,1.229,0,0,0,.344,8.3l2.8,2.85a.544.544,0,0,1,.146.467l-.667,4.027a1.21,1.21,0,0,0,.25.971A1.125,1.125,0,0,0,4.29,16.9L7.751,15a.5.5,0,0,1,.471,0l3.461,1.9a1.1,1.1,0,0,0,.533.14,1.131,1.131,0,0,0,.879-.43,1.209,1.209,0,0,0,.25-.971l-.661-4.026a.544.544,0,0,1,.146-.467Z",
    transform: "translate(.008 -1.043)",
    fill: "#999"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoStar24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_star24x24.17f7e5ef8d5d5dc56e04e709b981e70a.svg";